export function PauseIcon({ width = 33 }: { width?: number }) {
  return (
    <svg width={width} height="29" viewBox="0 0 24 24">
      <path d="M 5.9998494,-4.225e-5 A 2,2 0 0 0 3.9999715,1.9998356 V 22.000165 a 2,2 0 0 0 1.9998779,1.999877 2,2 0 0 0 1.999878,-1.999877 V 1.9998356 A 2,2 0 0 0 5.9998494,-4.225e-5 Z m 12.0003006,0 A 2,2 0 0 0 15.999756,1.9998356 V 22.000165 a 2,2 0 0 0 2.000394,1.999877 2,2 0 0 0 1.999878,-1.999877 V 1.9998356 A 2,2 0 0 0 18.00015,-4.225e-5 Z" />
    </svg>
  );
}
